// extracted by mini-css-extract-plugin
export var link = "_uz-0";